import * as _ from "lodash";
import { ReactElement, FC } from "react";
import { useSelector } from "react-redux";

import {
  Enterprise,
  EnterpriseAppState,
  FarmEntity,
  GamePlanEntity,
  TodoItemList,
  TodoItemStatus,
  UserEntity
} from "@ctra/api";

interface BaseProps {
  gamePlanID?: GamePlanEntity["id"];
  farmID?: FarmEntity["id"];
  userID?: UserEntity["id"];
  status?: TodoItemStatus;
}
interface TodoListProviderProps extends BaseProps {
  children: (taskList: TodoItemList) => ReactElement | null;
}

/**
 * Get a list of to-do items for the given game plan
 * @param gamePlanID
 * @param farmID
 * @param status
 * @param userID
 * @param children
 * @constructor
 */
export const TodoListProvider: FC<TodoListProviderProps> = ({
  gamePlanID,
  farmID,
  status,
  userID,
  children
}) => {
  /**
   * Get to-do list for the given game plan or farm id
   */
  let todoList = useSelector<EnterpriseAppState, TodoItemList>((state) =>
    Enterprise.entities.getTodoList(state, { gamePlanID, status, farmID, withMeta: true })
  );

  if (userID) {
    todoList = _.pickBy(todoList, ["assignedTo", userID]);
  }

  return children(todoList);
};
